import emailNotificationSaga from 'sagas/setting/emailNotification'

export {
  emailNotificationSaga
}



// WEBPACK FOOTER //
// ./app/sagas/setting/index.js